module.exports = __webpack_public_path__ + "static/img/rank-bg.d1119aea.webp";